
// // import React, { useState } from "react";
// // import { useNavigate, Link, useSearchParams } from "react-router-dom";
// // import { useAuth } from "hooks/useAuth";
// // import api from "api/axiosConfig";
// // import SEO from "components/SEO";
// // import { trackEvent } from "utils/analytics";

// // const Signup = () => {
// //   const { signUp } = useAuth();
// //   const navigate = useNavigate();
// //   const [searchParams] = useSearchParams();

// //   const plan = (searchParams.get("plan") || "starter").toLowerCase() === "pro" ? "pro" : "starter";

// //   const [fullName, setFullName] = useState("");
// //   const [email, setEmail] = useState("");
// //   const [activationEmail, setActivationEmail] = useState("");
// //   const [activationSent, setActivationSent] = useState(false);

// //   const [password, setPassword] = useState("");
// //   const [confirmPassword, setConfirmPassword] = useState("");

// //   const [error, setError] = useState("");
// //   const [message, setMessage] = useState("");
// //   const [loading, setLoading] = useState(false);
// //   const [resending, setResending] = useState(false);

// //   const getLoginPath = () => {
// //     if (plan === "pro") {
// //       return "/login?next=" + encodeURIComponent("/pricing?subscribe=pro&interval=monthly");
// //     }
// //     return "/login";
// //   };

// //   const handleSignUp = async (e) => {
// //     e.preventDefault();

// //     if (password !== confirmPassword) {
// //       setError("Passwords do not match");
// //       return;
// //     }

// //     if (password.length < 8) {
// //       setError("Password must be at least 8 characters long");
// //       return;
// //     }

// //     setError("");
// //     setMessage("");
// //     setLoading(true);

// //     try {
// //       const res = await signUp(fullName, email, password);

// //       if (!res.success) {
// //         setError(res.error?.message || "Signup failed");
// //         return;
// //       }
// //       trackEvent("sign_up", {
// //         method: "email",
// //         plan,
// //       });

// //       setActivationEmail(email);
// //       setActivationSent(true);

// //       if (plan === "pro") {
// //         localStorage.setItem("selectedPlan", "pro");
// //         localStorage.setItem("selectedInterval", "monthly");
// //         localStorage.setItem("pendingPlan", "pro");
// //       } else {
// //         localStorage.removeItem("pendingPlan");
// //         localStorage.removeItem("selectedPlan");
// //       }

// //       setMessage(
// //         res.data?.message ||
// //           "Account created. Please verify your email before login."
// //       );
// //     } catch (err) {
// //       console.error("❌ Signup failed:", err.response?.data || err.message);
// //       setError(err.response?.data?.message || err.message || "Signup failed.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const resendActivationLink = async () => {
// //     const targetEmail = activationEmail || email;

// //     if (!targetEmail) {
// //       setError("Please enter your email first.");
// //       return;
// //     }

// //     setError("");
// //     setMessage("");
// //     setResending(true);

// //     try {
// //       const res = await api.apiBase.post("/api/auth/resend-verification", {
// //         email: targetEmail,
// //       });

// //       setMessage(res.data?.message || "Activation link resent successfully.");
// //     } catch (err) {
// //       console.error("❌ Resend activation failed:", err.response?.data || err);
// //       setError(
// //         err.response?.data?.message ||
// //           err.message ||
// //           "Failed to resend activation link."
// //       );
// //     } finally {
// //       setResending(false);
// //     }
// //   };

// //   if (activationSent) {
// //     return (
// //       <div className="flex min-h-screen bg-gradient-to-br from-purple-400 via-pink-400 to-orange-300 items-center justify-center p-6 font-sans">
// //         <div className="w-full max-w-lg bg-gray-100 rounded-2xl shadow-2xl px-10 py-10 flex flex-col justify-center text-center">
// //           <h2 className="text-3xl font-bold text-gray-800 mb-3">
// //             Verify Your Email
// //           </h2>

// //           <p className="text-gray-600 mb-4">
// //             We sent an activation link to:
// //           </p>

// //           <p className="font-semibold text-gray-900 mb-6">
// //             {activationEmail}
// //           </p>

// //           {plan === "pro" && (
// //             <p className="text-sm text-pink-700 bg-pink-50 border border-pink-100 rounded-lg px-4 py-3 mb-4">
// //               After email verification and login, we will take you to the Pro checkout page.
// //             </p>
// //           )}

// //           {message && (
// //             <p className="text-green-600 text-sm mb-4">{message}</p>
// //           )}

// //           {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

// //           <button
// //             type="button"
// //             onClick={resendActivationLink}
// //             disabled={resending}
// //             className="w-full h-12 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
// //           >
// //             {resending ? "Sending..." : "Resend Activation Link"}
// //           </button>

// //           <button
// //             type="button"
// //             onClick={() => navigate(getLoginPath())}
// //             className="mt-4 text-blue-600 font-medium hover:underline"
// //           >
// //             Go to Login
// //           </button>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <>
// //       <SEO
// //         title="Sign Up - TestimonialsHub"
// //         description="Create your free TestimonialsHub account to collect video testimonials, text reviews, and display customer feedback with beautiful widgets."
// //         keywords="signup testimonial software, create testimonial account, video testimonial platform, customer review tool"
// //         path="/signup"
// //       />
// //       <div className="flex min-h-screen bg-gradient-to-br from-purple-400 via-pink-400 to-orange-300 items-center justify-center p-6 font-sans">
// //         <div className="w-full max-w-lg bg-gray-100 rounded-2xl shadow-2xl px-10 py-5 flex flex-col justify-center">
// //           <h2 className="text-3xl font-bold text-gray-800 mb-3 text-center">
// //             Create Account
// //           </h2>

// //           <p className="text-base text-gray-500 mb-3 text-center">
// //             Join TestimonialsHub to collect and showcase customer testimonials.
// //           </p>

// //           <p className="text-sm text-center text-gray-600 mb-6">
// //             Selected plan: <b>{plan === "pro" ? "Pro" : "Starter (Free)"}</b>
// //           </p>

// //           <form onSubmit={handleSignUp} className="space-y-5">
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Full Name
// //               </label>
// //               <input
// //                 type="text"
// //                 value={fullName}
// //                 onChange={(e) => setFullName(e.target.value)}
// //                 placeholder="Your name"
// //                 required
// //                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
// //               />
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Email
// //               </label>
// //               <input
// //                 type="email"
// //                 value={email}
// //                 onChange={(e) => {
// //                   setEmail(e.target.value);
// //                   setActivationEmail(e.target.value);
// //                 }}
// //                 placeholder="you@example.com"
// //                 required
// //                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
// //               />
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Password
// //               </label>
// //               <input
// //                 type="password"
// //                 value={password}
// //                 onChange={(e) => setPassword(e.target.value)}
// //                 placeholder="Minimum 8 characters"
// //                 required
// //                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
// //               />
// //             </div>

// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Confirm Password
// //               </label>
// //               <input
// //                 type="password"
// //                 value={confirmPassword}
// //                 onChange={(e) => setConfirmPassword(e.target.value)}
// //                 placeholder="Confirm password"
// //                 required
// //                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
// //               />
// //             </div>

// //             <label className="flex items-start gap-2 text-sm text-gray-700 pt-2">
// //               <input
// //                 type="checkbox"
// //                 required
// //                 className="mt-1 rounded text-blue-600 focus:ring-blue-500"
// //               />
// //               <span>
// //                 I agree to the{" "}
// //                 <button
// //                   type="button"
// //                   className="text-blue-600 hover:underline"
// //                   onClick={() => navigate("/terms-and-conditions")}
// //                 >
// //                   Terms of Service
// //                 </button>{" "}
// //                 and{" "}
// //                 <button
// //                   type="button"
// //                   className="text-blue-600 hover:underline"
// //                   onClick={() => navigate("/privacy-policy")}
// //                 >
// //                   Privacy Policy
// //                 </button>
// //               </span>
// //             </label>

// //             <button
// //               type="submit"
// //               disabled={loading}
// //               className="w-full h-12 mt-4 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
// //             >
// //               {loading ? "Creating..." : "Create Account"}
// //             </button>
// //           </form>

// //           {message && (
// //             <p className="text-green-600 text-sm mt-4 text-center">{message}</p>
// //           )}

// //           {error && (
// //             <p className="text-red-500 text-sm mt-4 text-center">{error}</p>
// //           )}

// //           <p className="text-sm text-center text-gray-600 mt-6">
// //             Already have an account?{" "}
// //             <Link to={getLoginPath()} className="text-blue-600 font-medium hover:underline">
// //               Log in
// //             </Link>
// //           </p>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default Signup;
// import React, { useState } from "react";
// import { useNavigate, Link, useSearchParams } from "react-router-dom";
// import { useAuth } from "hooks/useAuth";
// import api from "api/axiosConfig";
// import SEO from "components/SEO";
// import { trackEvent } from "utils/analytics";

// const Signup = () => {
//   const { signUp } = useAuth();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const plan =
//     (searchParams.get("plan") || "starter").toLowerCase() === "pro"
//       ? "pro"
//       : "starter";

//   const [fullName, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [activationEmail, setActivationEmail] = useState("");
//   const [activationSent, setActivationSent] = useState(false);

//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [resending, setResending] = useState(false);

//   const getLoginPath = () => {
//     if (plan === "pro") {
//       return (
//         "/login?next=" +
//         encodeURIComponent("/pricing?subscribe=pro&interval=monthly")
//       );
//     }
//     return "/login";
//   };

//   const handleSignUp = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       setError("Passwords do not match");
//       return;
//     }

//     if (password.length < 8) {
//       setError("Password must be at least 8 characters long");
//       return;
//     }

//     setError("");
//     setMessage("");
//     setLoading(true);

//     try {
//       const res = await signUp(fullName, email, password);

//       if (!res.success) {
//         setError(res.error?.message || "Signup failed");
//         return;
//       }

//       trackEvent("sign_up", {
//         method: "email",
//         plan,
//       });

//       setActivationEmail(email);
//       setActivationSent(true);

//       if (plan === "pro") {
//         localStorage.setItem("selectedPlan", "pro");
//         localStorage.setItem("selectedInterval", "monthly");
//         localStorage.setItem("pendingPlan", "pro");
//       } else {
//         localStorage.removeItem("pendingPlan");
//         localStorage.removeItem("selectedPlan");
//       }

//       setMessage(
//         res.data?.message ||
//           "Account created. Please verify your email before login."
//       );
//     } catch (err) {
//       console.error("❌ Signup failed:", err.response?.data || err.message);
//       setError(err.response?.data?.message || err.message || "Signup failed.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resendActivationLink = async () => {
//     const targetEmail = activationEmail || email;

//     if (!targetEmail) {
//       setError("Please enter your email first.");
//       return;
//     }

//     setError("");
//     setMessage("");
//     setResending(true);

//     try {
//       const res = await api.apiBase.post("/api/auth/resend-verification", {
//         email: targetEmail,
//       });

//       setMessage(res.data?.message || "Activation link resent successfully.");
//     } catch (err) {
//       console.error("❌ Resend activation failed:", err.response?.data || err);
//       setError(
//         err.response?.data?.message ||
//           err.message ||
//           "Failed to resend activation link."
//       );
//     } finally {
//       setResending(false);
//     }
//   };

//   const AuthLayout = ({ children }) => (
//     <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-pink-50 via-white to-orange-50 px-6 py-8 font-sans">
//       <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-pink-300/40 blur-3xl" />
//       <div className="absolute right-0 top-20 h-96 w-96 rounded-full bg-purple-300/30 blur-3xl" />
//       <div className="absolute bottom-0 right-20 h-96 w-96 rounded-full bg-orange-300/40 blur-3xl" />

//       <div className="relative z-10 mx-auto mb-10 flex max-w-6xl items-center justify-between rounded-full border border-white/70 bg-white/85 px-6 py-4 shadow-xl shadow-pink-200/30 backdrop-blur-md">
//         <Link
//           to="/"
//           className="text-2xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500"
//         >
//           TestimonialsHub
//         </Link>

//         <div className="hidden items-center gap-8 text-sm font-semibold text-gray-600 md:flex">
//           <Link to="/" className="hover:text-pink-500 transition">
//             Product
//           </Link>
//           <Link to="/#features" className="hover:text-pink-500 transition">
//             Features
//           </Link>
//           <Link to="/pricing" className="hover:text-pink-500 transition">
//             Pricing
//           </Link>
//           <Link to="/resources" className="hover:text-pink-500 transition">
//             Resources
//           </Link>
//         </div>

//         <Link
//           to={getLoginPath()}
//           className="rounded-full bg-gradient-to-r from-pink-500 to-orange-400 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-pink-300/50 transition hover:scale-105"
//         >
//           Sign In
//         </Link>
//       </div>

//       {children}
//     </div>
//   );

//   if (activationSent) {
//     return (
//       <>
//         <SEO
//           title="Verify Email - TestimonialsHub"
//           description="Verify your email address to activate your TestimonialsHub account."
//           keywords="verify testimonial account, testimonialshub email verification"
//           path="/signup"
//         />

//         <AuthLayout>
//           <div className="relative z-10 mx-auto flex min-h-[calc(100vh-140px)] max-w-6xl items-center justify-center">
//             <div className="w-full max-w-lg rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
//               <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-10 text-center sm:px-10">
//                 <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-white shadow-lg shadow-pink-300/50">
//                   ✉
//                 </div>

//                 <h2 className="text-4xl font-black tracking-tight text-gray-900">
//                   Verify Your Email
//                 </h2>

//                 <p className="mt-4 text-base text-gray-600">
//                   We sent an activation link to:
//                 </p>

//                 <p className="mt-2 rounded-2xl border border-pink-100 bg-white px-4 py-3 font-bold text-gray-900 shadow-sm">
//                   {activationEmail}
//                 </p>

//                 {plan === "pro" && (
//                   <p className="mt-5 rounded-2xl border border-pink-100 bg-pink-50 px-4 py-3 text-sm font-medium text-pink-700">
//                     After email verification and login, we will take you to the
//                     Pro checkout page.
//                   </p>
//                 )}

//                 {message && (
//                   <div className="mt-5 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
//                     {message}
//                   </div>
//                 )}

//                 {error && (
//                   <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-600">
//                     {error}
//                   </div>
//                 )}

//                 <button
//                   type="button"
//                   onClick={resendActivationLink}
//                   disabled={resending}
//                   className="mt-6 h-14 w-full rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
//                 >
//                   {resending ? "Sending..." : "Resend Activation Link"}
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => navigate(getLoginPath())}
//                   className="mt-5 font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
//                 >
//                   Go to Login
//                 </button>
//               </div>
//             </div>
//           </div>
//         </AuthLayout>
//       </>
//     );
//   }

//   return (
//     <>
//       <SEO
//         title="Sign Up - TestimonialsHub"
//         description="Create your free TestimonialsHub account to collect video testimonials, text reviews, and display customer feedback with beautiful widgets."
//         keywords="signup testimonial software, create testimonial account, video testimonial platform, customer review tool"
//         path="/signup"
//       />

//       <AuthLayout>
//         <div className="relative z-10 mx-auto grid min-h-[calc(100vh-140px)] max-w-6xl items-center gap-10 lg:grid-cols-2">
//           <div className="hidden lg:block">
//             <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white bg-white/80 px-4 py-2 text-sm font-semibold text-gray-700 shadow-lg">
//               <span className="h-2.5 w-2.5 rounded-full bg-purple-500" />
//               Create your social proof engine
//             </div>

//             <h1 className="max-w-xl text-6xl font-black leading-tight tracking-tight text-gray-900">
//               Start collecting{" "}
//               <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500">
//                 testimonials that build trust.
//               </span>
//             </h1>

//             <p className="mt-6 max-w-lg text-lg leading-8 text-gray-600">
//               Create your account, collect customer stories, and showcase them
//               using beautiful widgets, portfolio pages, and review embeds.
//             </p>

//             <div className="mt-10 space-y-4">
//               <div className="flex items-center gap-4">
//                 <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
//                   ✓
//                 </div>
//                 <p className="text-base font-semibold text-gray-700">
//                   Collect video and text testimonials
//                 </p>
//               </div>

//               <div className="flex items-center gap-4">
//                 <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
//                   ★
//                 </div>
//                 <p className="text-base font-semibold text-gray-700">
//                   Showcase reviews with beautiful widgets
//                 </p>
//               </div>

//               <div className="flex items-center gap-4">
//                 <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
//                   ↗
//                 </div>
//                 <p className="text-base font-semibold text-gray-700">
//                   Grow conversions with authentic social proof
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="mx-auto w-full max-w-lg">
//             <div className="relative rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
//               <div className="absolute -right-5 -top-5 hidden rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 p-4 text-white shadow-xl md:block">
//                 ✨
//               </div>

//               <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-8 sm:px-10">
//                 <div className="mb-7 text-center">
//                   <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-white shadow-lg shadow-pink-300/50">
//                     👤
//                   </div>

//                   <h2 className="text-4xl font-black tracking-tight text-gray-900">
//                     Create Account
//                   </h2>

//                   <p className="mt-3 text-base text-gray-500">
//                     Join TestimonialsHub and start collecting reviews.
//                   </p>

//                   <div className="mx-auto mt-4 inline-flex rounded-full border border-pink-100 bg-white px-4 py-2 text-sm font-bold text-gray-700 shadow-sm">
//                     Selected plan:&nbsp;
//                     <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500">
//                       {plan === "pro" ? "Pro" : "Starter Free"}
//                     </span>
//                   </div>
//                 </div>

//                 <form onSubmit={handleSignUp} className="space-y-4">
//                   <div>
//                     <label className="mb-2 block text-sm font-bold text-gray-700">
//                       Full Name
//                     </label>
//                     <input
//                       type="text"
//                       value={fullName}
//                       onChange={(e) => setFullName(e.target.value)}
//                       placeholder="Your name"
//                       required
//                       className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
//                     />
//                   </div>

//                   <div>
//                     <label className="mb-2 block text-sm font-bold text-gray-700">
//                       Email Address
//                     </label>
//                     <input
//                       type="email"
//                       value={email}
//                       onChange={(e) => {
//                         setEmail(e.target.value);
//                         setActivationEmail(e.target.value);
//                       }}
//                       placeholder="you@example.com"
//                       required
//                       className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
//                     />
//                   </div>

//                   <div>
//                     <label className="mb-2 block text-sm font-bold text-gray-700">
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       placeholder="Minimum 8 characters"
//                       required
//                       className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
//                     />
//                   </div>

//                   <div>
//                     <label className="mb-2 block text-sm font-bold text-gray-700">
//                       Confirm Password
//                     </label>
//                     <input
//                       type="password"
//                       value={confirmPassword}
//                       onChange={(e) => setConfirmPassword(e.target.value)}
//                       placeholder="Confirm password"
//                       required
//                       className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
//                     />
//                   </div>

//                   <label className="flex items-start gap-3 rounded-2xl border border-pink-100 bg-white/80 px-4 py-3 text-sm text-gray-700 shadow-sm">
//                     <input
//                       type="checkbox"
//                       required
//                       className="mt-1 rounded border-pink-300 text-pink-500 focus:ring-pink-400"
//                     />
//                     <span>
//                       I agree to the{" "}
//                       <button
//                         type="button"
//                         className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
//                         onClick={() => navigate("/terms-and-conditions")}
//                       >
//                         Terms of Service
//                       </button>{" "}
//                       and{" "}
//                       <button
//                         type="button"
//                         className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
//                         onClick={() => navigate("/privacy-policy")}
//                       >
//                         Privacy Policy
//                       </button>
//                     </span>
//                   </label>

//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
//                   >
//                     <span className="relative z-10">
//                       {loading ? "Creating..." : "Create Account"}
//                     </span>
//                     <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
//                   </button>
//                 </form>

//                 {message && (
//                   <div className="mt-5 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-center text-sm font-medium text-green-700">
//                     {message}
//                   </div>
//                 )}

//                 {error && (
//                   <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-600">
//                     {error}
//                   </div>
//                 )}

//                 <p className="mt-6 text-center text-sm text-gray-600">
//                   Already have an account?{" "}
//                   <Link
//                     to={getLoginPath()}
//                     className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
//                   >
//                     Log in
//                   </Link>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </AuthLayout>
//     </>
//   );
// };

// export default Signup;

import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import api from "api/axiosConfig";
import SEO from "components/SEO";
import { trackEvent } from "utils/analytics";

/**
 * IMPORTANT:
 * AuthLayout must stay OUTSIDE Signup component.
 * If it is declared inside Signup, React recreates it on every state update,
 * causing input fields to lose focus while typing.
 */
const AuthLayout = ({ children, loginPath = "/login" }) => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-pink-50 via-white to-orange-50 px-6 py-8 font-sans">
      <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-pink-300/40 blur-3xl" />
      <div className="absolute right-0 top-20 h-96 w-96 rounded-full bg-purple-300/30 blur-3xl" />
      <div className="absolute bottom-0 right-20 h-96 w-96 rounded-full bg-orange-300/40 blur-3xl" />

      <div className="relative z-10 mx-auto mb-10 flex max-w-6xl items-center justify-between rounded-full border border-white/70 bg-white/85 px-6 py-4 shadow-xl shadow-pink-200/30 backdrop-blur-md">
        <Link
          to="/"
          className="text-2xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500"
        >
          TestimonialsHub
        </Link>

        <div className="hidden items-center gap-8 text-sm font-semibold text-gray-600 md:flex">
          <Link to="/" className="transition hover:text-pink-500">
            Product
          </Link>
          <Link to="/#features" className="transition hover:text-pink-500">
            Features
          </Link>
          <Link to="/pricing" className="transition hover:text-pink-500">
            Pricing
          </Link>
          <Link to="/resources" className="transition hover:text-pink-500">
            Resources
          </Link>
        </div>

        <Link
          to={loginPath}
          className="rounded-full bg-gradient-to-r from-pink-500 to-orange-400 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-pink-300/50 transition hover:scale-105"
        >
          Sign In
        </Link>
      </div>

      {children}
    </div>
  );
};

const Signup = () => {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const plan =
    (searchParams.get("plan") || "starter").toLowerCase() === "pro"
      ? "pro"
      : "starter";

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [activationEmail, setActivationEmail] = useState("");
  const [activationSent, setActivationSent] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const getLoginPath = () => {
    if (plan === "pro") {
      return (
        "/login?next=" +
        encodeURIComponent("/pricing?subscribe=pro&interval=monthly")
      );
    }

    return "/login";
  };

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    setError("");
    setMessage("");
    setLoading(true);

    try {
      const res = await signUp(fullName, email, password);

      if (!res.success) {
        setError(res.error?.message || "Signup failed");
        return;
      }

      trackEvent("sign_up", {
        method: "email",
        plan,
      });

      setActivationEmail(email);
      setActivationSent(true);

      if (plan === "pro") {
        localStorage.setItem("selectedPlan", "pro");
        localStorage.setItem("selectedInterval", "monthly");
        localStorage.setItem("pendingPlan", "pro");
      } else {
        localStorage.removeItem("pendingPlan");
        localStorage.removeItem("selectedPlan");
      }

      setMessage(
        res.data?.message ||
          "Account created. Please verify your email before login."
      );
    } catch (err) {
      console.error("❌ Signup failed:", err.response?.data || err.message);
      setError(err.response?.data?.message || err.message || "Signup failed.");
    } finally {
      setLoading(false);
    }
  };

  const resendActivationLink = async () => {
    const targetEmail = activationEmail || email;

    if (!targetEmail) {
      setError("Please enter your email first.");
      return;
    }

    setError("");
    setMessage("");
    setResending(true);

    try {
      const res = await api.apiBase.post("/api/auth/resend-verification", {
        email: targetEmail,
      });

      setMessage(res.data?.message || "Activation link resent successfully.");
    } catch (err) {
      console.error("❌ Resend activation failed:", err.response?.data || err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to resend activation link."
      );
    } finally {
      setResending(false);
    }
  };

  if (activationSent) {
    return (
      <>
        <SEO
          title="Verify Email - TestimonialsHub"
          description="Verify your email address to activate your TestimonialsHub account."
          keywords="verify testimonial account, testimonialshub email verification"
          path="/signup"
        />

        <AuthLayout loginPath={getLoginPath()}>
          <div className="relative z-10 mx-auto flex min-h-[calc(100vh-140px)] max-w-6xl items-center justify-center">
            <div className="w-full max-w-lg rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
              <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-10 text-center sm:px-10">
                <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-2xl text-white shadow-lg shadow-pink-300/50">
                  ✉
                </div>

                <h2 className="text-4xl font-black tracking-tight text-gray-900">
                  Verify Your Email
                </h2>

                <p className="mt-4 text-base text-gray-600">
                  We sent an activation link to:
                </p>

                <p className="mt-2 rounded-2xl border border-pink-100 bg-white px-4 py-3 font-bold text-gray-900 shadow-sm">
                  {activationEmail}
                </p>

                {plan === "pro" && (
                  <p className="mt-5 rounded-2xl border border-pink-100 bg-pink-50 px-4 py-3 text-sm font-medium text-pink-700">
                    After email verification and login, we will take you to the
                    Pro checkout page.
                  </p>
                )}

                {message && (
                  <div className="mt-5 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
                    {message}
                  </div>
                )}

                {error && (
                  <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-600">
                    {error}
                  </div>
                )}

                <button
                  type="button"
                  onClick={resendActivationLink}
                  disabled={resending}
                  className="mt-6 h-14 w-full rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {resending ? "Sending..." : "Resend Activation Link"}
                </button>

                <button
                  type="button"
                  onClick={() => navigate(getLoginPath())}
                  className="mt-5 font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                >
                  Go to Login
                </button>
              </div>
            </div>
          </div>
        </AuthLayout>
      </>
    );
  }

  return (
    <>
      <SEO
        title="Sign Up - TestimonialsHub"
        description="Create your free TestimonialsHub account to collect video testimonials, text reviews, and display customer feedback with beautiful widgets."
        keywords="signup testimonial software, create testimonial account, video testimonial platform, customer review tool"
        path="/signup"
      />

      <AuthLayout loginPath={getLoginPath()}>
        <div className="relative z-10 mx-auto grid min-h-[calc(100vh-140px)] max-w-6xl items-center gap-10 lg:grid-cols-2">
          <div className="hidden lg:block">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white bg-white/80 px-4 py-2 text-sm font-semibold text-gray-700 shadow-lg">
              <span className="h-2.5 w-2.5 rounded-full bg-purple-500" />
              Create your social proof engine
            </div>

            <h1 className="max-w-xl text-6xl font-black leading-tight tracking-tight text-gray-900">
              Start collecting{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500">
                testimonials that build trust.
              </span>
            </h1>

            <p className="mt-6 max-w-lg text-lg leading-8 text-gray-600">
              Create your account, collect customer stories, and showcase them
              using beautiful widgets, portfolio pages, and review embeds.
            </p>

            <div className="mt-10 space-y-4">
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
                  ✓
                </div>
                <p className="text-base font-semibold text-gray-700">
                  Collect video and text testimonials
                </p>
              </div>

              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
                  ★
                </div>
                <p className="text-base font-semibold text-gray-700">
                  Showcase reviews with beautiful widgets
                </p>
              </div>

              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-orange-400 text-white shadow-lg">
                  ↗
                </div>
                <p className="text-base font-semibold text-gray-700">
                  Grow conversions with authentic social proof
                </p>
              </div>
            </div>
          </div>

          <div className="mx-auto w-full max-w-lg">
            <div className="relative rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
              <div className="absolute -right-5 -top-5 hidden rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 p-4 text-white shadow-xl md:block">
                ✨
              </div>

              <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-8 sm:px-10">
                <div className="mb-7 text-center">
                  <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-2xl text-white shadow-lg shadow-pink-300/50">
                    👤
                  </div>

                  <h2 className="text-4xl font-black tracking-tight text-gray-900">
                    Create Account
                  </h2>

                  <p className="mt-3 text-base text-gray-500">
                    Join TestimonialsHub and start collecting reviews.
                  </p>

                  <div className="mx-auto mt-4 inline-flex rounded-full border border-pink-100 bg-white px-4 py-2 text-sm font-bold text-gray-700 shadow-sm">
                    Selected plan:&nbsp;
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500">
                      {plan === "pro" ? "Pro" : "Starter Free"}
                    </span>
                  </div>
                </div>

                <form onSubmit={handleSignUp} className="space-y-4">
                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Full Name
                    </label>

                    <input
                      type="text"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      placeholder="Your name"
                      required
                      className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Email Address
                    </label>

                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setActivationEmail(e.target.value);
                      }}
                      placeholder="you@example.com"
                      required
                      className="h-12 w-full rounded-2xl border border-pink-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Password
                    </label>

                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Minimum 8 characters"
                      required
                      className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Confirm Password
                    </label>

                    <input
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm password"
                      required
                      className="h-12 w-full rounded-2xl border border-orange-100 bg-white px-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
                    />
                  </div>

                  <label className="flex items-start gap-3 rounded-2xl border border-pink-100 bg-white/80 px-4 py-3 text-sm text-gray-700 shadow-sm">
                    <input
                      type="checkbox"
                      required
                      className="mt-1 rounded border-pink-300 text-pink-500 focus:ring-pink-400"
                    />

                    <span>
                      I agree to the{" "}
                      <button
                        type="button"
                        className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                        onClick={() => navigate("/terms-and-conditions")}
                      >
                        Terms of Service
                      </button>{" "}
                      and{" "}
                      <button
                        type="button"
                        className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                        onClick={() => navigate("/privacy-policy")}
                      >
                        Privacy Policy
                      </button>
                    </span>
                  </label>

                  <button
                    type="submit"
                    disabled={loading}
                    className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    <span className="relative z-10">
                      {loading ? "Creating..." : "Create Account"}
                    </span>
                    <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                  </button>
                </form>

                {message && (
                  <div className="mt-5 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-center text-sm font-medium text-green-700">
                    {message}
                  </div>
                )}

                {error && (
                  <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-600">
                    {error}
                  </div>
                )}

                <p className="mt-6 text-center text-sm text-gray-600">
                  Already have an account?{" "}
                  <Link
                    to={getLoginPath()}
                    className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                  >
                    Log in
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </AuthLayout>
    </>
  );
};

export default Signup;